module.exports = __webpack_public_path__ + "img/ICON_26.96f0b495.png";